var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('p',[_vm._v("Pemeriksaan Kesehatan")]),_vm._v(" "),_c('data-table',{staticClass:"display table table-bordered table-hover",attrs:{"columns":_vm.columns,"ajax":_vm.ajax}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }